/* eslint-disable no-unused-vars */
"use client";

import { Box, Divider, Flex, Text, VStack } from "@chakra-ui/react";
import { motion } from "framer-motion";
import moment from "moment/moment";
import { useState } from "react";
import { formatFieldName } from "../../../../utils/formatFieldName";
import NewMergeTable from "./NewMergeTable";
const NewMergeCase = ({ data, setMergedFinalData, mergedFinalData }) => {
  const [highlightedFields, setHighlightedFields] = useState({});

  const selectedData = data.map((entry) => {
    return Object.fromEntries(
      Object.entries(entry).filter(([_, value]) => !Array.isArray(value))
    );
  });

  const handleFieldSelect = (fieldName, value) => {
    setMergedFinalData((prev) => {
      const updatedData = { ...prev, [fieldName]: value };
      return updatedData;
    });
    // Trigger highlight animation
    setHighlightedFields((prev) => ({
      ...prev,
      [fieldName]: true,
    }));
    // Remove highlight after a delay
    setTimeout(() => {
      setHighlightedFields((prev) => ({
        ...prev,
        [fieldName]: false,
      }));
    }, 1000);
  };

  const MotionDiv = motion.div;
  const allKeys = Array.from(
    new Set(selectedData.flatMap((item) => Object.keys(item)))
  );
  return (
    <Box p={4} borderRadius="md" bg="#fff">
      <Flex justifyContent="space-between" gap={5}>
        <Box p={4} w="70%">
          <NewMergeTable
            demoCaseData={selectedData}
            onFieldSelect={handleFieldSelect}
            selectedValues={mergedFinalData}
          />
        </Box>
        <Box
          w="30%"
          bg="gray.200"
          p={4}
          borderRadius="md"
          maxH="480px"
          overflowY="scroll"
          scrollBehavior="smooth"
        >
          <Text fontWeight={600} mb={2} textAlign="center">
            Preview
          </Text>
          <VStack spacing={2} align="start">
            {allKeys.map((key) => {
              const originalValue = selectedData[0][key]; // fallback from first record
              const mergedValue = mergedFinalData[key];
              const valueToDisplay = mergedValue || originalValue;
              const isHighlighted = highlightedFields[key];

              const formattedValue = moment(
                valueToDisplay,
                moment.ISO_8601,
                true
              ).isValid()
                ? moment(valueToDisplay).format("YYYY-MM-DD")
                : valueToDisplay;

              return (
                <Text key={key} fontSize="sm">
                  <Text as="span" fontWeight={600}>
                    {formatFieldName(key)}
                  </Text>
                  {": "}
                  <MotionDiv
                    initial={false}
                    animate={
                      isHighlighted
                        ? { backgroundColor: "#FEF9C3", opacity: 1 }
                        : { backgroundColor: "transparent", opacity: 1 }
                    }
                    transition={{ duration: 0.8 }}
                    style={{
                      display: "inline-block",
                      padding: "0 4px",
                      borderRadius: "4px",
                    }}
                  >
                    {formattedValue}
                  </MotionDiv>
                </Text>
              );
            })}
          </VStack>
        </Box>
      </Flex>

      <Divider borderColor="gray.300" mt={2} />
    </Box>
  );
};

export default NewMergeCase;
